












































































































import Component from 'vue-class-component';
import { namespace } from 'vuex-class';
import { CreateUserData } from '@/modules/backend/Dto/CreateUserData';
import { UserName } from '@/modules/backend/Entities/UserName';
import { Mixins, Prop, Ref } from 'vue-property-decorator';
import EditDialogWrapper from '@/layouts/EditDialogWrapper.vue';
import Mixin from '@/mixins/base';
import { Role } from '@/modules/backend/Entities/Role';
import ProvidersModule from '@/store/dashboard/providers/ProvidersModule';
import { resolveModule } from '@/store';
import { CompaniesModule } from '@/store/dashboard/companies/CompaniesModule';
import { Provider } from '@/modules/backend/Entities/Provider';
import { ValidationObserver } from '@/plugins/vee-validate';

const UsersModule = namespace('dashboard/users');
const RolesModule = namespace('dashboard/roles');

interface AddUserForm {
  lastName: string;
  firstName: string;
  patronymic: string;
  email: string;
  password: string;
}

@Component({
  mixins: [Mixin],
  components: {
    'edit-dialog-wrapper': EditDialogWrapper
  }
})
export default class UserCreateDialog extends Mixins(Mixin) {
  @Ref('observer')
  private readonly observer!: ValidationObserver;

  @UsersModule.Action('Create')
  private readonly createUser!: (payload: CreateUserData) => Promise<void>;

  @RolesModule.Action('List')
  private readonly fetchRoles!: () => Promise<void>;

  @RolesModule.Getter('Roles')
  private readonly roles!: Role[];

  private get providers(): Provider[] {
    return this.providersModule.providers;
  }

  private readonly providersModule: ProvidersModule = resolveModule(ProvidersModule);

  private readonly companiesModule: CompaniesModule = resolveModule(CompaniesModule);

  @Prop({ default: () => undefined })
  private readonly accountId!: number | undefined;

  @Prop({ type: String })
  private readonly icon!: string | undefined;

  private selectedCompanies: number[] = [];
  private selectedProviders: number[] = [];
  private selectedRoles: number[] = [];

  private form: AddUserForm = {
    firstName: '',
    lastName: '',
    patronymic: '',
    email: '',
    password: ''
  };

  private async dialogOpenHandler(): Promise<void> {
    this.clearForm();

    await Promise.all([
      this.providersModule.fetch(),
      this.companiesModule.Fetch(),
      this.fetchRoles(),
    ]);
    if (this.accountId) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const accountRole: any = this.roles.find(role => role.isAccount);
      if (!accountRole) {
        return;
      }
      this.selectedRoles = [accountRole];
    }
  }

  public async create(): Promise<void> {
    this.observer.reset();

    if (await this.observer.validate()) {
      const payload = new CreateUserData();
      payload.email = this.form.email;
      payload.password = this.form.password;
      payload.companyIds = this.selectedCompanies;
      payload.providerIds = this.selectedProviders;

      if (typeof this.accountId === 'undefined') {
        payload.roleIds = this.selectedRoles;
      } else {
        const result: number[] = [];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.selectedRoles.forEach((item: any) => {
          result.push(item.id);
        });
        payload.roleIds = result;
      }
      payload.name = new UserName(
        this.form.firstName,
        this.form.lastName,
        this.form.patronymic
      );
      payload.accountId = this.accountId;

      await this.createUser(payload);
    } else {
      throw new Error('Validation error');
    }
  }

  private clearForm(): void {
    this.form.firstName = '';
    this.form.lastName = '';
    this.form.patronymic = '';
    this.form.email = '';
    this.form.password = '';
    this.selectedCompanies = [];
    this.selectedProviders = [];
    this.selectedRoles = [];
    this.observer.reset();
  }
}
